import {
  SET_HISTORY,
  SET_HISTORY_COUNT,
  SET_HISTORY_RECORDS,
  SET_HISTORY_RECORDS_COUNT,
  SET_HISTORY_RECORDS_PATIENT,
  SET_NOTIFICATIONS_RECORDS, 
  SET_NOTIFICATIONS_RECORDS_COUNT, 
} from '../../constants';

const initialState = {
  historyList: [],
  historyCount: 0,
  historyRecords: [],
  historyRecordsCount: 0,
  recordPatient: null,
  notificationRecords: [], 
  notificationRecordsCount: 0, 
};

const historyReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_HISTORY:
      return { ...state, historyList: action.history };
    case SET_HISTORY_COUNT:
      return { ...state, historyCount: action.count };
    case SET_HISTORY_RECORDS:
      return { ...state, historyRecords: action.records };
    case SET_HISTORY_RECORDS_COUNT:
      return { ...state, historyRecordsCount: action.count };
    case SET_HISTORY_RECORDS_PATIENT:
      return { ...state, recordPatient: action.patient };
    case SET_NOTIFICATIONS_RECORDS: 
      return { ...state, notificationRecords: action.records };
    case SET_NOTIFICATIONS_RECORDS_COUNT: 
      return { ...state, notificationRecordsCount: action.count };
    default:
      return state;
  }
};

export default historyReducer;
